<template src="./MyPatients.html"></template>
<script>
import mixins from "../../../../Mixins.js";
import history from "../../Patient/History/History.vue";
export default {
  components: {
    history
  },
  mixins: [mixins],
  name: "my-patients",
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      showButtonSmallScrren: false,
      patients: [],
      listPatients: true,
      idPatient: 0
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getPendency();
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 1100) {
        vm.showWebTable = false;
        if (vm.window.width < 420) {
          vm.showButtonSmallScrren = true;
        }else {
          vm.showButtonSmallScrren = false;
        }
      } else {
        vm.showWebTable = true;
      }
    },
    goToHistoric(idPatient) {
      const vm = this;
      vm.idPatient = idPatient;
      vm.listPatients = false;
    },
    getPendency() {
      const vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer +
            "doctor/my-patients?page=0&size=50&sort=id,asc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 20,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          vm.patients = response.data.content;
        });
    }
  }
};
</script>
<style lang="scss" src="./MyPatients.scss">
</style>
